import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=c544810a&scoped=true"
import script from "./CSelect.vue?vue&type=script&lang=js"
export * from "./CSelect.vue?vue&type=script&lang=js"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=c544810a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c544810a",
  null
  
)

export default component.exports